import { z } from 'zod'

export const StaticVersionApiSchemas = {
  checkVersion: {
    path: z.undefined(),
    query: z.undefined(),
    request: z.undefined(),
    response: z.record(z.string().or(z.number()), z.string()),
  },
}
